import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    GET_WHITE_LISTED_DEVICES,
    CREATE_WHITE_LISTED_DEVICE,
    EDIT_WHITE_LISTED_DEVICE,
    DELETE_WHITE_LISTED_DEVICE,
    CLOSE_WHITE_LISTED_DEVICE_DIALOG
} from "./types";

export const getWhiteListedDevices = () => (dispatch) => {
    axios
        .get(`whiteListedDevice/with-users`)
        .then((res) => {
            if (res.data.status) {
                console.log("White Listed Devices action: ", res.data.devices);
                dispatch({ type: GET_WHITE_LISTED_DEVICES, payload: res.data.devices });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
export const createNewWhiteListedDevice = (data) => (dispatch) => {
    axios
        .post(`whiteListedDevice`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "White Listed Device created successfully!");
                dispatch({ type: CLOSE_WHITE_LISTED_DEVICE_DIALOG });
                dispatch({ type: CREATE_WHITE_LISTED_DEVICE, payload: res.data.device });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
export const editWhiteListedDevice = (mongoId, data) => (dispatch) => {
    axios
        .put(`whiteListedDevice/${mongoId}`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "White Listed Device updated successfully!");
                dispatch({ type: CLOSE_WHITE_LISTED_DEVICE_DIALOG });
                dispatch({
                    type: EDIT_WHITE_LISTED_DEVICE,
                    payload: { data: res.data.device, id: mongoId },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
export const deleteWhiteListedDevice = (mongoId) => (dispatch) => {
    axios
        .delete(`whiteListedDevice/${mongoId}`)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: DELETE_WHITE_LISTED_DEVICE, payload: mongoId });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => console.log(error));
};

export const AccessibleFunctionWhiteListedDevice = (data) => (dispatch) => {
    axios
        .patch(`whiteListedDevice`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Accessible Function update successfully!");
                dispatch({
                    type: EDIT_WHITE_LISTED_DEVICE,
                    payload: { data: res.data.whiteListedDevice, id: res.data.whiteListedDevice._id },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};
